import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';
import './Breadcrumbs.css';

function Breadcrumbs() {
  const location = useLocation();

  const crumbs = location.pathname
    .split('/')
    .filter((crumb) => crumb !== '')
    .map((crumb, index, arr) => {
      const path = `/${arr.slice(0, index + 1).join('/')}`;
      return (
        <span key={path} className="breadcrumb-item">
          <Link
            to={path}
            aria-current={index === arr.length - 1 ? 'page' : undefined}
            className="breadcrumb-link"
          >
            {crumb.replace(/-/g, ' ')}
          </Link>
          {index < arr.length - 1 && (
            <FaChevronRight
              className="breadcrumb-separator"
              aria-hidden="true"
            />
          )}
        </span>
      );
    });

  return (
    <nav aria-label="breadcrumb">
      <div className="breadcrumbs">
        <Link to="/" className="breadcrumb-home" aria-label="Home">
          <FaHome className="breadcrumb-icon" />
        </Link>
        {crumbs.length > 0 && (
          <FaChevronRight className="breadcrumb-separator" aria-hidden="true" />
        )}
        {crumbs}
      </div>
    </nav>
  );
}

export default Breadcrumbs;
